import React from 'react';
import { ArrowForward, HelpOutline } from '@mui/icons-material';
import { Card, IconButton, Link, Row, Stack, Title } from 'library/ui';
import { useUserContext } from 'UserContext';
import QRCodeCard from './business/QRCodeCard';

const MAX_VISIBLE = 4;

export default function PaymentLocationQRCodes() {
    const { user, getDisplayText } = useUserContext();
    const addresses = user?.address ?? [];

    const tooltipTxt = `Providers can scan QR codes on arrival at your ${getDisplayText(
        'center',
    )} to report their hours. Download your QR codes here and place them where providers can access them at the beginning and end of their shifts to ensure their hours and payments are accurate.`;

    return (
        <Card padding="lg" fullHeight>
            <Stack gap="md">
                <Row justify="between" align="center">
                    <Row gap="sm" align="center">
                        <Title size="h2">Center QR Codes</Title>
                        <IconButton icon={HelpOutline} tooltip={tooltipTxt} />
                    </Row>
                    {addresses.length > MAX_VISIBLE && (
                        <Link to="/payments/qr-codes">
                            View all <ArrowForward sx={{ fontSize: 16 }} />
                        </Link>
                    )}
                </Row>
                <Stack gap="sm">
                    {addresses.slice(0, MAX_VISIBLE).map((address) => (
                        <QRCodeCard key={address.id} address={address} />
                    ))}
                </Stack>
            </Stack>
        </Card>
    );
}
